export enum AdobeAnalyticsUserRole {
  DEVELOPER = 'Developer',
  LOCAL_USER = 'Local User',
  GLOBAL_USER = 'Global User',
  ANONYMOUS = 'Anonymous',
}
